webpackJsonp([233530150144089],{

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/final.d5482731.png";

/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _final = __webpack_require__(194);
	
	var _final2 = _interopRequireDefault(_final);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 8: Save User in Context'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'re going to save the current user to context, so that any component in the application can easily retrieve it.'
	    ),
	    _react2.default.createElement(_QuickstartBranch2.default, { branch: 'authentication.8' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'The Master Component'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Inside the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'src/components'
	      ),
	      ' folder is a component named ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Master'
	      ),
	      '. This component is intended to serve as a wrapper around your application, and has three main functions:'
	    ),
	    _react2.default.createElement(
	      'ol',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Subscribe to the Redux store, so the application will re-render when the store changes'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Fetch any data that needs to be retrieved before the application is rendered'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Remove the loading screen once the application is ready to display to the user'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step, we\'ll be focusing on the second function, and fetching the the current user before we render the main application.'
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'You can learn more about the ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'Master'
	        ),
	        ' component ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/anatomy/src/components/master/' },
	          'here'
	        ),
	        '.'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Fetch the Current User in Master'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Let\'s start by using the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'connect'
	      ),
	      ' decorator to fetch the current user when the application loads, and rendering a loading experience until we have it. Update the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Master'
	      ),
	      ' component to look like this:'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        // src/components/Master.js\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import { connect } from \'lore-hook-connect\';\n        import PayloadStates from \'../constants/PayloadStates\';\n        import RemoveLoadingScreen from \'./RemoveLoadingScreen\';\n        import \'../../assets/css/main.css\';\n\n        export default connect(function(getState, props) {\n          return {\n            user: getState(\'currentUser\')\n          };\n        }, { subscribe: true })(\n          createReactClass({\n            displayName: \'Master\',\n\n            render() {\n              const { user } = this.props;\n\n              if (user.state === PayloadStates.FETCHING) {\n                return (\n                  <div className="loader" />\n                );\n              }\n\n              return (\n                <div>\n                  <RemoveLoadingScreen />\n                  {React.cloneElement(this.props.children)}\n                </div>\n              );\n            }\n\n          })\n        );\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        // src/components/Master.js\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import { connect } from \'lore-hook-connect\';\n        import PayloadStates from \'../constants/PayloadStates\';\n        import RemoveLoadingScreen from \'./RemoveLoadingScreen\';\n        import \'../../assets/css/main.css\';\n\n        class Master extends React.Component {\n\n          render() {\n            const { user } = this.props;\n\n            if (user.state === PayloadStates.FETCHING) {\n              return (\n                <div className="loader" />\n              );\n            }\n\n            return (\n              <div>\n                <RemoveLoadingScreen />\n                {React.cloneElement(this.props.children)}\n              </div>\n            );\n          }\n\n        }\n\n        Master.propTypes = {\n          user: PropTypes.object.isRequired\n        };\n\n        export default connect(function(getState, props) {\n          return {\n            user: getState(\'currentUser\')\n          };\n        }, { subscribe: true })(Master);\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        // src/components/Master.js\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import { connect } from \'lore-hook-connect\';\n        import PayloadStates from \'../constants/PayloadStates\';\n        import RemoveLoadingScreen from \'./RemoveLoadingScreen\';\n        import \'../../assets/css/main.css\';\n\n        @connect(function(getState, props) {\n          return {\n            user: getState(\'currentUser\')\n          };\n        }, { subscribe: true })\n        class Master extends React.Component {\n\n          static propTypes = {\n            user: PropTypes.object.isRequired\n          };\n\n          render() {\n            const { user } = this.props;\n\n            if (user.state === PayloadStates.FETCHING) {\n              return (\n                <div className="loader" />\n              );\n            }\n\n            return (\n              <div>\n                <RemoveLoadingScreen />\n                {React.cloneElement(this.props.children)}\n              </div>\n            );\n          }\n\n        }\n\n        export default Master;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Save the User in Context'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we\'re going to save the current user to ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://reactjs.org/docs/context.html' },
	        'context'
	      ),
	      ', so that any component that needs it can access it. Update the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Master'
	      ),
	      ' component to include the necessary fields:'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        // src/components/Master.js\n        ...\n        createReactClass({\n          ...\n\n          propTypes: {\n            user: PropTypes.object.isRequired\n          },\n\n          childContextTypes: {\n            user: PropTypes.object\n          },\n\n          getChildContext() {\n            return {\n              user: this.props.user\n            };\n          },\n\n          render() {\n            ...\n          }\n\n        })\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        // src/components/Master.js\n        ...\n\n        class Master extends React.Component {\n\n          getChildContext() {\n            return {\n              user: this.props.user\n            };\n          }\n\n          ...\n\n        }\n\n        Master.propTypes = {\n          user: PropTypes.object.isRequired\n        };\n\n        Master.childContextTypes = {\n          user: PropTypes.object\n        };\n\n        ...\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        // src/components/Master.js\n        ...\n        class Master extends React.Component {\n\n          static propTypes = {\n            user: PropTypes.object.isRequired\n          };\n\n          static childContextTypes = {\n            user: PropTypes.object\n          };\n\n          getChildContext() {\n            return {\n              user: this.props.user\n            };\n          }\n\n          ...\n\n        }\n        ...\n        ' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the code above we\'ve added ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'childContextTypes'
	      ),
	      ', to declare that an object named ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'user'
	      ),
	      ' should be made available to all child components in the application, and added a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'getChildContext()'
	      ),
	      ' method that provides the value of that object, which is our current user.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Update Profile to Use Context'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next, open the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Profile'
	      ),
	      ' component and modify it to retrieve the current user from ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'context'
	      ),
	      ' instead of ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'props'
	      ),
	      ':'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        // src/components/Profile.js\n        ...\n\n        export default createReactClass({\n          ...\n\n          contextTypes: {\n            user: PropTypes.object.isRequired\n          },\n\n          ...\n\n          render() {\n            const { user } = this.context;\n            ...\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        // src/components/Profile.js\n        ...\n        class Profile extends React.Component {\n          ...\n          render() {\n            const { user } = this.context;\n            ...\n          }\n        }\n\n        Profile.contextTypes = {\n          user: PropTypes.object.isRequired\n        };\n\n        export default Profile;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        // src/components/Profile.js\n        ...\n        class Profile extends React.Component {\n\n          static contextTypes = {\n            user: PropTypes.object.isRequired\n          };\n\n          ...\n\n          render() {\n            const { user } = this.context;\n            ...\n          }\n        }\n\n        export default Profile;\n        ' })
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'At this point, we no longer need the ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'getDefaultProps()'
	        ),
	        ' method, so feel free to delete it.'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If everything went well, your application should now look like this.'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _final2.default }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Code Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Below is a list of files modified during this step.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/components/Master.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n        import { connect } from \'lore-hook-connect\';\n        import PayloadStates from \'../constants/PayloadStates\';\n        import RemoveLoadingScreen from \'./RemoveLoadingScreen\';\n        import \'../../assets/css/main.css\';\n\n        export default connect(function(getState, props) {\n          return {\n            user: getState(\'currentUser\')\n          };\n        }, { subscribe: true })(\n          createReactClass({\n            displayName: \'Master\',\n\n            propTypes: {\n              user: PropTypes.object.isRequired\n            },\n\n            childContextTypes: {\n              user: PropTypes.object\n            },\n\n            getChildContext() {\n              return {\n                user: this.props.user\n              };\n            },\n\n            render() {\n              const { user } = this.props;\n\n              if (user.state === PayloadStates.FETCHING) {\n                return (\n                  <div className="loader" />\n                );\n              }\n\n              return (\n                <div>\n                  <RemoveLoadingScreen />\n                  {React.cloneElement(this.props.children)}\n                </div>\n              );\n            }\n\n          })\n        );\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import { connect } from \'lore-hook-connect\';\n        import PayloadStates from \'../constants/PayloadStates\';\n        import RemoveLoadingScreen from \'./RemoveLoadingScreen\';\n        import \'../../assets/css/main.css\';\n\n        class Master extends React.Component {\n\n          getChildContext() {\n            return {\n              user: this.props.user\n            };\n          }\n\n          render() {\n            const { user } = this.props;\n\n            if (user.state === PayloadStates.FETCHING) {\n              return (\n                <div className="loader" />\n              );\n            }\n\n            return (\n              <div>\n                <RemoveLoadingScreen />\n                {React.cloneElement(this.props.children)}\n              </div>\n            );\n          }\n\n        }\n\n        Master.propTypes = {\n          user: PropTypes.object.isRequired\n        };\n\n        Master.childContextTypes = {\n          user: PropTypes.object\n        };\n\n        export default connect(function(getState, props) {\n          return {\n            user: getState(\'currentUser\')\n          };\n        }, { subscribe: true })(Master);\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import { connect } from \'lore-hook-connect\';\n        import PayloadStates from \'../constants/PayloadStates\';\n        import RemoveLoadingScreen from \'./RemoveLoadingScreen\';\n        import \'../../assets/css/main.css\';\n\n        @connect(function(getState, props) {\n          return {\n            user: getState(\'currentUser\')\n          };\n        }, { subscribe: true })\n        class Master extends React.Component {\n\n          static propTypes = {\n            user: PropTypes.object.isRequired\n          };\n\n          static childContextTypes = {\n            user: PropTypes.object\n          };\n\n          getChildContext() {\n            return {\n              user: this.props.user\n            };\n          }\n\n          render() {\n            const { user } = this.props;\n\n            if (user.state === PayloadStates.FETCHING) {\n              return (\n                <div className="loader" />\n              );\n            }\n\n            return (\n              <div>\n                <RemoveLoadingScreen />\n                {React.cloneElement(this.props.children)}\n              </div>\n            );\n          }\n\n        }\n\n        export default Master;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/components/Profile.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n        import { Link } from \'react-router\';\n\n        export default createReactClass({\n          displayName: \'Profile\',\n\n          contextTypes: {\n            user: PropTypes.object.isRequired\n          },\n\n          render() {\n            const { user } = this.context;\n\n            return (\n              <div className="card profile">\n                <div className="card-block">\n                  <img\n                    className="img-circle avatar"\n                    src={user.data.avatar} />\n                  <h4 className="card-title">\n                    Hi {user.data.nickname}!\n                  </h4>\n                  <div className="card-text">\n                    <p>You have permission to perform the following:</p>\n                    <ul className="permissions">\n                      <li>Create Tweets</li>\n                      <li>Edit your own tweets</li>\n                      <li>Delete your own tweets</li>\n                    </ul>\n                  </div>\n                  <Link className="btn btn-primary" to="/logout">\n                    Log out\n                  </Link>\n                </div>\n              </div>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import { Link } from \'react-router\';\n\n        class Profile extends React.Component {\n\n          render() {\n            const { user } = this.context;\n\n            return (\n              <div className="card profile">\n                <div className="card-block">\n                  <img\n                    className="img-circle avatar"\n                    src={user.data.avatar} />\n                  <h4 className="card-title">\n                    Hi {user.data.nickname}!\n                  </h4>\n                  <div className="card-text">\n                    <p>You have permission to perform the following:</p>\n                    <ul className="permissions">\n                      <li>Create Tweets</li>\n                      <li>Edit your own tweets</li>\n                      <li>Delete your own tweets</li>\n                    </ul>\n                  </div>\n                  <Link className="btn btn-primary" to="/logout">\n                    Log out\n                  </Link>\n                </div>\n              </div>\n            );\n          }\n\n        }\n\n        Profile.contextTypes = {\n          user: PropTypes.object.isRequired\n        };\n\n        export default Profile;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import { Link } from \'react-router\';\n\n        class Profile extends React.Component {\n\n          static contextTypes = {\n            user: PropTypes.object.isRequired\n          };\n\n          render() {\n            const { user } = this.context;\n\n            return (\n              <div className="card profile">\n                <div className="card-block">\n                  <img\n                    className="img-circle avatar"\n                    src={user.data.avatar} />\n                  <h4 className="card-title">\n                    Hi {user.data.nickname}!\n                  </h4>\n                  <div className="card-text">\n                    <p>You have permission to perform the following:</p>\n                    <ul className="permissions">\n                      <li>Create Tweets</li>\n                      <li>Edit your own tweets</li>\n                      <li>Delete your own tweets</li>\n                    </ul>\n                  </div>\n                  <Link className="btn btn-primary" to="/logout">\n                    Log out\n                  </Link>\n                </div>\n              </div>\n            );\n          }\n\n        }\n\n        export default Profile;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the next section we\'re going to ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../../server/overview/' },
	        'replace the mock server with a real server'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-authentication-step-8-js-8314aa47521add0d8518.js